<style scoped lang="scss">
.wrapper {
  padding-bottom: 10px;
}

.student-count {
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 13px;

  span {
    color: #FF2828;
  }
}

.room-wrapper {
  margin: 0 12px 0 30px;

  .room-item {
    vertical-align: middle;
    margin: 0 18px 18px 0;
    position: relative;
    display: inline-block;
    width: 216px;
    height: 130px;
    border: 1px solid $color-theme;
    border-radius: 4px;

    .delete {
      position: absolute;
      right: -6px;
      top: -6px;
      width: 18px;
      height: 18px;
      background-image: url('~images/delete.png');
      background-size: cover;
      cursor: pointer;
    }

    .room-header {
      height: 42px;
      line-height: 42px;
      border-bottom: 1px solid #F5F5F5;

      h6 {
        display: inline-block;
        text-indent: 10px;
        color: $color-theme;
      }

      img {
        display: inline-block;
        vertical-align: middle;
        margin: -6px 0 0 10px;
        cursor: pointer;
      }
    }

    .num-wrapper {
      padding: 8px 8px 8px 12px;

      .num {
        font-size: 14px;
        height: 20px;
        line-height: 22px;
      }
    }
  }

  .add-room {
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    p {
      height: 26px;
      line-height: 32px;
      color: $color-theme;
      font-size: 14px;
      font-weight: bold;
    }

    &:hover {
      background: #F5F5F5;
      cursor: pointer;
    }
  }
}
</style>

<style lang="scss">
.num-wrapper {
  .el-slider__runway.show-input {
    width: 95px;
  }

  .el-input-number--mini {
    line-height: 28px;
  }

  .el-slider__button {
    width: 12px;
    height: 12px;
    background: $color-theme;
  }

  .el-slider__input {
    width: 92px;
  }

  .el-input__inner {
    padding: 0;
    color: $color-theme;
  }
}
</style>

<template>
  <div class="wrapper">

    <el-form label-width="150px" class="demo-ruleForm">

      <el-form-item size="small" label="考号生成方式：">
        <el-form-item prop="date1" style="display: inline-block;">
          <el-select v-model="finalType" size="small" placeholder="自定义前缀">
            <el-option v-for="item in taskList" :key="item.type" :label="item.name" :value="item.type">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="date1" style="display: inline-block;" v-if="finalType === 0">
          <el-input type="text" v-model="prefix" size="small" placeholder="请输入前缀，例如KS"></el-input>
        </el-form-item>
      </el-form-item>

      <el-form-item size="small" label="考场个数：">
        <el-form-item prop="date1" style="display: inline-block;">
          <el-input type="number" v-model="roomCount" size="small" placeholder="请输入考场个数"></el-input>
        </el-form-item>

        <el-button type="primary" size="small" @click="_previewRoom()">预览</el-button>
      </el-form-item>
    </el-form>

    <p class="student-count">参考学生总数 <span>{{ examStudentCount }} </span>，已分配座位 <span>{{ seatingCount }}</span></p>

    <ul class="room-wrapper">
      <li class="room-item" v-for="(item, index) in roomList" :key="index">
        <i class="delete" @click="_deleteRoom(index)"></i>
        <div class="room-header">
          <h6>{{ item.name }} 考场</h6>
          <img src="~images/tool/edit.png" width="18" @click="_showEditDilaog(item)" />
        </div>
        <div class="num-wrapper">
          <div class="num">人数</div>
          <el-slider v-model="item.count" show-input :max=100 @change="_countChange" input-size="mini">
          </el-slider>
        </div>
      </li>

      <li class="room-item">
        <div class="add-room" @click="_addRoom()">
          <img src="~images/tool/add.png" width="46" />
          <p>添加考场</p>
        </div>
      </li>
    </ul>

    <div style="padding: 20px;text-align: center;">
      <el-button type="primary" size="medium" :type="examStudentCount !== seatingCount ? 'info' : 'primary'"
        @click="_createExamTask()" :loading="submitLoading">确认生成考务</el-button>
    </div>

    <yue-dialog title="编辑考场" :visible.sync="editDialog" width="500px" center>
      <div style="padding: 30px 40px 0 30px;">
        <el-form label-width="100px">
          <el-form-item label="考场名称：">
            <el-input maxlength=2 v-model="roomName" placeholder="请输入阿拉伯数字"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialog = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="_saveRoomEdit()">确 定</el-button>
      </span>
    </yue-dialog>
  </div>
</template>

<script>
import { createExamTask } from '@/api/tool'

export default {
  data () {
    return {
      disabled: true,
      params: {},
      examStudentCount: 0,
      seatingCount: 0,
      student: {},
      prefix: '',
      roomCount: 0,
      finalType: 1,
      taskList: [
        { name: '自定义前缀生成', type: 0 },
        { name: '流水号生成 ', type: 1 }
      ],
      roomList: [],
      room: {},
      submitLoading: false,
      editDialog: false,
      roomName: '',
    }
  },
  mounted () {
    this.$emit("setStep", 2)

    this.params = JSON.parse(window.YJ_SCHOOL_STORAGE.getItem('examTask'))

    if (this.$route.query.code) {
      this.params.importCode = this.$route.query.code
    }

    this.examStudentCount = this.params.examStudentCount
  },

  methods: {
    _showEditDilaog (item) {
      this.editDialog = true
      this.room = item
      this.roomName = item.name
    },

    _saveRoomEdit () {
      for (let item of this.roomList) {
        if (this.roomName === item.name) {
          this.$message({
            type: 'warning',
            message: '考场名称重复'
          })
          return
        }
        if (Number(this.roomName) != this.roomName) {
          this.$message({
            type: 'warning',
            message: '考场名称只能是阿拉伯数字'
          })
          return
        }
        if (!this.roomName) {
          this.$message({
            type: 'warning',
            message: '考场名称不能为空'
          })
          return
        }
      }

      this.room.name = this.roomName
      this.editDialog = false
    },

    async _createExamTask () {
      if (this.examStudentCount !== this.seatingCount) {
        return
      }

      this.submitLoading = true

      let roomList = []
      for (let item of this.roomList) {
        let obj = {
          num: item.count,
          room: item.name
        }
        roomList.push(obj)
      }

      if (this.finalType === 0) {
        if (this.prefix === '') {
          this.$message({
            message: '请填写自定义前缀',
            type: 'warning'
          })

          this.submitLoading = false

          return
        }

        this.params.examineNumberPrefix = this.prefix
      }

      if (this.roomList.length === 0) {
        this.$message({
          message: '请分配考场',
          type: 'warning'
        })
        return
      }
      if (this.finalType === 0) {
        MtaH5.clickStat("toolsetcustompre")
      } else {
        MtaH5.clickStat("toolsetbyflow")
      }
      this.params.finalType = this.finalType
      this.params.allotRoomsParams = roomList

      let resp = await createExamTask(this.params)

      this.submitLoading = false

      if (resp.body) {
        window.YJ_SCHOOL_STORAGE.removeItem('examTask')
        this.$router.replace(`/tool/task/create/third?id=${resp.body.manageId}&gradeId=${this.params.gradeId}`)
      } else {
        this.$message.warning(resp.message)
      }
    },

    _countChange () {
      let seatingCount = 0
      for (let item of this.roomList) {
        seatingCount += item.count
      }

      this.seatingCount = seatingCount
    },

    // 添加考场
    _addRoom () {
      let i = this.roomList.length + 1
      let obj = {
        id: i,
        name: i < 10 ? '0' + i : i,
        count: 0
      }
      this.roomList.push(obj)

      this.roomCount = this.roomList.length
    },

    // 预览考场
    _previewRoom () {
      MtaH5.clickStat("toolsetroompreview")
      if (!this.roomCount) {
        this.$message({
          message: '考场个数不能小于1',
          type: 'warning'
        })
        return
      }

      let perRoomStudentCount = 0 // 每个考场学生数
      let lastRoomStudentCount = 0 // 最后一个考场学生数
      lastRoomStudentCount = this.examStudentCount % this.roomCount
      perRoomStudentCount = parseInt(this.examStudentCount / this.roomCount)
      lastRoomStudentCount = perRoomStudentCount + lastRoomStudentCount

      if (perRoomStudentCount > 100 || lastRoomStudentCount > 100) {
        this.$message({
          type: 'warning',
          message: '每个考场学生不能超过100人！'
        })
        return
      }

      let roomList = []
      for (let i = 1; i <= this.roomCount; i++) {
        let obj = {
          id: i,
          name: i < 10 ? '0' + i : i,
          count: i == this.roomCount ? lastRoomStudentCount : perRoomStudentCount
        }
        roomList.push(obj)
      }

      this.roomList = roomList
      this.seatingCount = this.examStudentCount
    },

    _deleteRoom (index) {
      this.$confirm('确定要删除此考场吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.roomList.splice(index, 1)

        let seatingCount = 0
        for (let item of this.roomList) {
          seatingCount += item.count
        }

        this.seatingCount = seatingCount

        this.roomCount = this.roomList.length

        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }).catch(() => {

      })
    }
  }
}
</script>